import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from "Ressources/dbh_helper";
import { dbh_custom_validation } from "../ClientValidation/dbh_custom_validation";

if (dbh_helper.getUrlController() == "betreuungsberichte") {
    $(document).ready(function () {
        let id = dbh_helper.getUrlParameter("id");
        if (id != "") {

        }

        $(document).on('click', '.tdBetreuungsberichtPos', function () {
            const rowid = $(this).data('rowid');
            dbh_helper.SendGetRequest("GetPositionPopupView", "Belegungen/Betreuungsberichte", [["id", rowid]], "#betreuungsberichtPosition-placeholder", () => { $('#betreuungsberichtPositionenViewComponentPopup').show(); });
        });

        $(document).on('click', '.betreuungsberichtPosResult .tableDeleteButton', function (e) {
            const rowid = $(this).data('rowid');
            dbh_helper.SendGetRequest("DeletePositionZuweisung", "Belegungen/Betreuungsberichte", [["id", rowid]], "#betreuungsberichtPosition-placeholder", () => { $('#betreuungsberichtDeleteViewComponentPopup').show(); });
            e.preventDefault();
            e.stopPropagation();
        });

        $(document).on('click', '#savePositionChangeBtn', function (e) {
            let dbhCustomValidation = new dbh_custom_validation();
            if (!dbhCustomValidation.validateForm("#betreuungsberichtPositionPopup")) {
                return;
            }

            const form = dbh_helper.findNearestForm(e.currentTarget);
            const parameter = dbh_helper.getParameterStringForForm(form);
            dbh_helper.FormatDatesParameterArray(parameter);

            dbh_helper.SendPostRequest('SavePositionChange', 'Belegungen/Betreuungsberichte', parameter, null, () => {
                sendReloadForBetreuungsberichtPos(id, '#betreuungsberichtPositionenViewComponentPopup');
            });
        });

        $(document).on('click', '#editBetreuungsberichtPositionCancelBtn', function () {
            $('#betreuungsberichtPositionenViewComponentPopup').hide();
        });

        $(document).on('click', '#deletePositionConfirmBtn', function () {
            const posId = $(this).data('id');
            dbh_helper.SendGetRequest("DeletePositionAfterConsent", "Belegungen/Betreuungsberichte", [["id", posId]], null, () => {
                sendReloadForBetreuungsberichtPos(id, '#betreuungsberichtDeleteViewComponentPopup');                
            });
        });

        $(document).on('click', '#cancelDeletePositionBtn', function () {
            $('#betreuungsberichtDeleteViewComponentPopup').hide();
        });

        $(document).on('click', '#addLeistungspositionBtn', function (e) {
            const form = dbh_helper.findNearestForm(e.currentTarget);

            let dbhCustomValidation = new dbh_custom_validation();
            if (!dbhCustomValidation.validateForm(form)) {
                return;
            }

            const parameter = dbh_helper.getParameterStringForForm(form);
            dbh_helper.FormatDatesParameterArray(parameter);

            sendPostRequest('AddPosition', 'Belegungen/Betreuungsberichte', parameter, null, () => {
                $('.addSvrError').html("");

                sendReloadForBetreuungsberichtPos(id);

                ($('#FromBetreuungsberichteAddPosition')[0] as HTMLFormElement).reset();
            }, (ajaxResult) => {
                $('.addSvrError').html(ajaxResult);
            });
        });

        $(document).on('click', '#addNotizBtn', function (e) {
            const form = dbh_helper.findNearestForm(e.currentTarget);

            let dbhCustomValidation = new dbh_custom_validation();
            if (!dbhCustomValidation.validateForm(form)) {
                return;
            }

            const parameter = dbh_helper.getParameterStringForForm(form);

            sendPostRequest('AddNotiz', 'Belegungen/Betreuungsberichte', parameter, null, () => {
                $('.addNotizenSvrError').html("");
                sendReloadForBetreuungsberichtNotizen(id);
                ($('#FormBetreuungsberichteAddNotiz')[0] as HTMLFormElement).reset();
            }, (ajaxResult) => {
                $('.addNotizenSvrError').html(ajaxResult);
            });
        });

        $(document).on('click', '.notizDeleteButton', function (e) {
            const rowid = $(this).data('rowid');
            if (confirm('Möchten Sie diese Notiz wirklich löschen?')) {
                dbh_helper.SendGetRequest('DeleteNotizAfterConsent', 'Belegungen/Betreuungsberichte', [['id', rowid]], null, () => {
                    sendReloadForBetreuungsberichtNotizen(id);
                });
            }
            e.preventDefault();
            e.stopPropagation();
        });

        dbh_helper.setDefaultFormValues();

    });
}

const sendPostRequest = (actionName, controllerName, parameter, htmlId, doOnSuccess = null, doOnError = null) => {

    return new dbh_ajax().sendPostRequest({
        actionName: actionName,
        controllerName: controllerName,
        parameter: parameter,
        loadingTarget: null,
        callbackSuccess: (ajaxResult: any) => {
            if (htmlId !== undefined && htmlId !== null) {
                $(`${htmlId}`).html(ajaxResult);
            }
            if (doOnSuccess !== undefined && doOnSuccess !== null) {
                doOnSuccess();
            }
        },
        callbackError: (ajaxResult: XMLHttpRequest) => {
            if (doOnError !== undefined && doOnError !== null) {
                doOnError(ajaxResult.responseText);
            }
        }
    });
}

const sendReloadForBetreuungsberichtPos = (id, hideId = undefined) => {
    const jsonPosTableInfo = $('#jsonPosTableInfo').val();
    const jsonGlobalInfo = $('#jsonGlobalInfo').val();

    const model = [
        ['id', id],
        ['jsonPosTableInfo', jsonPosTableInfo],
        ['jsonGlobalInfo', jsonGlobalInfo]
    ];

    dbh_helper.SendGetRequest('ReloadTable', 'Belegungen/Betreuungsberichte', model, '#betreuungsberichtePositionenTabelleMitSuche',
        () => {
            if (hideId) {
                $(hideId).hide();
            }
        });

    if ($("#BetreuungsberichteStundenUebersicht").length > 0)
    {
        dbh_helper.SendGetRequest('ReloadStunden', 'Belegungen/Betreuungsberichte', model, '#betreuungsberichteStundenUebersicht',
            () => {
                if (hideId) {
                    $(hideId).hide();
                }
            });
    }
}

const sendReloadForBetreuungsberichtNotizen = (id) => {
    dbh_helper.SendGetRequest('ReloadNotizen', 'Belegungen/Betreuungsberichte', [['id', id]], '#betreuungsberichteNotizenTabelle');
}